{
  "items": [
    {
      "name": "Inicio",
      "icon": "home",
      "route": "inicio",
      "showInMenu": true,
      "category": "General"
    },
    {
      "name": "Mis pólizas",
      "icon": "polizas",
      "route": "mis-polizas",
      "showInMenu": true,
      "category": "General"
    },
    {
      "name": "Rescate 365",
      "icon": "rescate",
      "route": "rescate-365",
      "showInMenu": true,
      "category": "Riesgo"
    },
    {
      "name": "Balances y pagos",
      "icon": "balances",
      "route": "balances-y-pagos",
      "showInMenu": true,
      "category": "General"
    },
    {
      "name": "Mis reclamos",
      "icon": "reclamos",
      "route": "mis-reclamos",
      "showInMenu": true,
      "category": "Riesgo"
    },
    {
      "name": "Cotizadores",
      "icon": "quotes",
      "route": "cotizadores",
      "showInMenu": true,
      "category": "General"
    },
    {
      "name": "Directorio médico",
      "icon": "directorio",
      "route": "salud-just/directorio-medico",
      "showInMenu": true,
      "category": "Salud"
    },
    {
      "name": "Mis solicitudes Just",
      "icon": "just",
      "route": "salud-just/autorizaciones-y-reembolsos",
      "showInMenu": true,
      "category": "Salud"
    },
    {
      "name": "Contáctanos",
      "icon": "contacto",
      "route": "contactanos",
      "showInMenu": true,
      "category": "General"
    },
    {
      "name": "Mi Cuenta",
      "icon": "menu-user",
      "route": "mi-cuenta",
      "showInMenu": false,
      "category": "General"
    }
  ]
}
